import { Location, SearchPlaceResult } from '@dialogue/coredata'
import { createSlice, type PayloadAction } from '@reduxjs/toolkit'
import { PlacesState } from './types'

export interface GetPlacesRequest {
  query: string
  /**
   * The origin can be a Location object or a place_id string.
   */
  origin: Location | string
  language_code?: string
}

const initialState: PlacesState = {
  list: {
    loading: false,
    error: null,
    data: [],
  },
}

const { actions, reducer } = createSlice({
  name: 'places',
  initialState,
  reducers: {
    getPlaces: (state, action: PayloadAction<GetPlacesRequest>) => {
      state.list.loading = true
      // Reference the action to avoid ESLint warning
      void action
    },
    getPlacesSuccess: (state, action: PayloadAction<SearchPlaceResult[]>) => {
      state.list.loading = false
      state.list.error = null
      state.list.data = action.payload
    },
    getPlacesFailure: (state, action: PayloadAction<{ error: Error }>) => {
      state.list.loading = false
      state.list.error = action.payload.error
    },
  },
})

export { actions as placesActions, initialState }

export default reducer
